import { Subscription } from 'rxjs';

export const subscriptions: Record<number, Subscription> = {};

interface EventSubscriptions {
    subscriptions: Record<number, Subscription>;
    addSubscription(eventId: number, subscription: Subscription): void;
    clearSubscriptions(): void;
    removeSubscription(eventId: number): void;
    hasSubscription(eventId: number): boolean;
}

// tslint:disable-next-line:variable-name
export const Subscriptions: EventSubscriptions = {
    addSubscription(eventId: number, subscription: Subscription) {
        if (eventId && !this.hasSubscription(eventId)) {
            this.subscriptions[eventId] = subscription;
        }
    },
    clearSubscriptions(): void {
        Object.keys(this.subscriptions).forEach((eventId: any) => {
            this.subscriptions[eventId].unsubscribe();
        });
        this.subscriptions = {};
    },
    hasSubscription(eventId: number): boolean {
        return !!this.subscriptions[eventId];
    },
    removeSubscription(eventId: number): void {
        if (this.hasSubscription(eventId)) {
            this.subscriptions[eventId].unsubscribe();
            delete this.subscriptions[eventId];
        }
    },
    subscriptions: {}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/sportOffer/Subscriptions.ts